import Vue from 'vue'
import Router from 'vue-router'

import HomeRoutes from './home'
import RegisterRoutes from './register'
import LoginRoutes from './login'
import ManageRoutes from './manage'
import BuypointRoutes from './buypoint'
// import AccountRoutes from './account'
// import CartRoutes from './cart'
// import OrderRoutes from './order'
// import CheckoutRoutes from './checkout'
// import OrdersRoutes from './orders'
import DashboardRoutes from './dashboard'
import PointsRoutes from './points'
import SellpointsRoutes from './sellpoints'
import SellpointRoutes from './sellpoint'
import CreateSellpointRoutes from './create'
// import ProductRoutes from './product'
// import PostRoutes from './post'
// import GalleryRoutes from './gallery'
import SideHustleRoutes from './sidehustle'


Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        HomeRoutes,
        RegisterRoutes,
        LoginRoutes,
        ManageRoutes,
        BuypointRoutes,
        //AccountRoutes,
        DashboardRoutes,
        PointsRoutes,
        // PostRoutes,
        // GalleryRoutes,
        CreateSellpointRoutes,
        SideHustleRoutes,
        // CartRoutes,
        // OrderRoutes,
        // CheckoutRoutes,
        // OrdersRoutes,
        SellpointsRoutes,
        SellpointRoutes,
        // ProductRoutes,
        // {path: '*', redirect: '/'} // 404
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js